export default __webpack_public_path__ + "static/media/permanentStation.69b12ae8.svg";